<template>
  <div class="w-full bg-slate-50 min-h-screen p-4 md:p-8" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="mb-8">
        <h1 class="text-2xl font-black text-slate-800 tracking-tight">Relatório de Veículos</h1>
        <p class="text-sm text-slate-500 font-medium mt-1">Gere a listagem completa de veículos por prefeitura</p>
      </div>

      <!-- CONFIGURAÇÕES DO RELATÓRIO -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-bus-multiple</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
                  PARÂMETROS DO RELATÓRIO
              </h2>
          </div>
          <div class="p-8">
              <v-row dense>
                <v-col cols="12">
                   <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Selecione a Prefeitura</label>
                  <v-autocomplete
                    :items="prefectures"
                    v-model="filter.prefecture_id"
                    item-value="prefecture_id"
                    item-text="prefecture_social_name"
                    placeholder="Busque por prefeitura..."
                    outlined dense hide-details="auto"
                    class="bg-slate-50 font-medium"
                    clearable
                    :readonly="!isAdmin"
                  />
                </v-col>
              </v-row>

              <div class="flex justify-end mt-8">
                  <button 
                    @click="navigateToVehicleReport"
                    :disabled="!filter.prefecture_id"
                    class="bg-orange-500 hover:bg-orange-600 text-white rounded-lg shadow-md shadow-orange-500/20 flex items-center justify-center gap-2 w-fit whitespace-nowrap px-8 h-10 transition-all transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed text-[11px] font-bold uppercase tracking-widest"
                  >
                      <v-icon color="white" small>mdi-file-download-outline</v-icon>
                      GERAR RELATÓRIO PDF
                  </button>
              </div>
          </div>
      </section>
    </div>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  mixins: [Helpers],
  data() {
    return {
      loader: false,
      prefectures: [],
      filter: {
        prefecture_id: null,
      },
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.getUserData.group_id === 1;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http.get("/prefectures").then((r) => {
          this.prefectures = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);

          if (this.$store.getters.getUserData.table_key === 'prefectures' && this.$store.getters.getUserData.table_id) {
            this.filter.prefecture_id = this.$store.getters.getUserData.table_id;
          } else if (this.$store.getters.getUserData.group_id !== 1) {
            this.filter.prefecture_id = this.$store.getters.getUserData.table_id;
          }
      }).catch(() => {
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
      });
    },
    navigateToVehicleReport() {
      const url = `${window.origin}/#/report/veiculos/${this.filter.prefecture_id}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
</style>
